export const FETCH_FAVOURITES = "FETCH_FAVOURITES";
export const FETCH_FAVOURITES_SUCCESS = "FETCH_FAVOURITES_SUCCESS";
export const FETCH_FAVOURITES_ERROR = "FETCH_FAVOURITES_ERROR";

export const ADD_TO_FAVOURITES = "ADD_TO_FAVOURITES";
export const ADD_TO_FAVOURITES_SUCCESS = "FETCH_FAVOURITES_SUCCESS";
export const ADD_TO_FAVOURITES_ERROR = "ADD_TO_FAVOURITES_ERROR";

export const REMOVE_FROM_FAVOURITES = "REMOVE_FROM_FAVOURITES";
export const REMOVE_FROM_FAVOURITES_SUCCESS = "REMOVE_FROM_FAVOURITES_SUCCESS";
export const REMOVE_FROM_FAVOURITES_ERROR = "REMOVE_FROM_FAVOURITES_ERROR";



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/favourites/constants.ts